import searcherry from '@/services/Searcherry/Searcherry'
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'

declare var searcherryGlobalConfig: any
searcherryConfig.load(searcherryGlobalConfig)
searcherry.loadStyles()

if (!searcherryGlobalConfig.oldSearchLink || !window.location.href.includes(searcherryGlobalConfig.oldSearchLink)) {
  let searcherryInterval = setInterval(() => {
    let searchEls: HTMLElement[] = []
    for (let sKey in searcherryConfig.siteSearchInputSelectors) {
      let selector = searcherryConfig.siteSearchInputSelectors[sKey]
      switch (selector.substring(0, 1)) {
        case '.':
          selector = selector.substring(1)
          let els = document.getElementsByClassName(selector) as HTMLCollectionOf<HTMLElement>
          for (let key in els) {
            let el = els[key]
            if (el instanceof HTMLElement) {
              searchEls.push(el)
            }
          }
          searchEls.push()
          break

        case '#':
          selector = selector.substring(1)
          let el = document.getElementById(selector)
          if (el !== null) {
            searchEls.push(el)
          }
          break
      }
    }

    if (searchEls.length > 0) {
      for (let key in searchEls) {
        if (searchEls[key].tagName) {
          let target = searchEls[key]
          let randomClass = 'srchrry' + Math.floor(100000 + Math.random() * 900000)
          // todo сделать проверку на одинаковые классы
          target.classList.add(randomClass)
          // Отменяем все слушатели на элементе
          void ['focus', 'click', 'focusin', 'focusout', 'input', 'keydown', 'keypress', 'keyup', 'change', 'blur', 'mousedown'].forEach(function (event) {
            window.addEventListener(event, function (e) {
              if (e.target === target) {
                e.stopImmediatePropagation()
                if (event === 'focus') {
                  searcherry.showSearcherry(randomClass)
                }
              }
            }, true)
          })

          if (target === document.activeElement) {
            searcherry.showSearcherry(randomClass)
          }
        }
      }

      clearInterval(searcherryInterval)
    }
  }, 100)

  if (location.hash.substr(0, 8) === '#/search') {
    searcherry.init()
  }
}
